<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    size="lg"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <!-- Período -->
      <b-form-group label="Período Académico">
        <b-form-select
          v-model="form.periodoId"
          :options="periodsOptions"
          placeholder="Seleccionar período"
          @change="onPeriodoChange"
        />
      </b-form-group>

      <!-- Carrera -->
      <b-form-group label="Carrera" class="mt-1">
        <b-form-select
          v-model="form.carreraId"
          :options="programsOptions"
          placeholder="Seleccionar carrera"
          @change="onCarreraChange"
        />
      </b-form-group>

      <!-- Estado -->
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="estadoOptions"
          placeholder="Seleccionar estado"
          :disabled="!isEdit"
        />
      </b-form-group>

      <!-- Observaciones -->
      <b-form-group label="Observaciones" class="mt-1">
        <b-form-textarea
          v-model="form.observaciones"
          placeholder="Ingrese observaciones (opcional)"
          rows="3"
          maxlength="500"
        />
      </b-form-group>

      <!-- Información de la Programación -->
      <b-alert 
        v-if="selectedPeriod && selectedProgram" 
        variant="info" 
        show 
        class="mt-3"
      >
        <h6 class="alert-heading mb-2">
          <feather-icon icon="InfoIcon" class="mr-1" />
          Información de la Programación
        </h6>
        <div class="row">
          <div class="col-md-4">
            <strong>Período:</strong><br>
            <span class="text-primary">{{ selectedPeriod.codigo }}</span>
          </div>
          <div class="col-md-4">
            <strong>Carrera:</strong><br>
            <span class="text-primary">{{ selectedProgram.nombre }}</span>
          </div>
          <div class="col-md-4">
            <strong>Facultad:</strong><br>
            <span class="text-primary">{{ selectedProgram.facultadNombre }}</span>
          </div>
        </div>
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormSelect, BFormTextarea, BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormTextarea,
    BAlert,
  },
  props: {
    schedulingData: {
      type: Object,
      default: null,
    },
    periods: {
      type: Array,
      default: () => [],
    },
    programs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        periodoId: null,
        carreraId: null,
        estado: null,
        observaciones: '',
      },
      estadoOptions: [
        { value: null, text: 'Seleccionar estado' },
        { value: 'Borrador', text: 'Borrador' },
        { value: 'En Revisión', text: 'En Revisión' },
        { value: 'Aprobada', text: 'Aprobada' },
        { value: 'Publicada', text: 'Publicada' },
      ],
      selectedPeriod: null,
      selectedProgram: null,
    }
  },
  computed: {
    modalId() {
      return 'scheduling-modal'
    },
    modalTitle() {
      return this.isEdit ? 'Editar Programación Académica' : 'Nueva Programación Académica'
    },
    isEdit() {
      return this.schedulingData && (this.schedulingData.id || this.schedulingData.programacionAcademicaId)
    },
    periodsOptions() {
      console.log('Períodos disponibles:', this.periods)
      const options = [
        { value: null, text: 'Seleccionar período' },
        ...this.periods.map(period => ({
          value: period.periodoId,
          text: period.codigo
        }))
      ]
      console.log('Opciones de períodos:', options)
      return options
    },
    programsOptions() {
      console.log('Carreras disponibles:', this.programs)
      const options = [
        { value: null, text: 'Seleccionar carrera' },
        ...this.programs.map(program => ({
          value: program.carreraId,
          text: program.nombre
        }))
      ]
      console.log('Opciones de carreras:', options)
      return options
    },
  },
  watch: {
    schedulingData: {
      handler(newData) {
        if (newData) {
          this.form = {
            periodoId: newData.periodoId || null,
            carreraId: newData.carreraId || null,
            estado: newData.estado || null,
            observaciones: newData.observaciones || '',
          }
          this.updateSelectedData()
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateSelectedData() {
      this.selectedPeriod = this.periods.find(p => p.periodoId === this.form.periodoId)
      this.selectedProgram = this.programs.find(p => p.carreraId === this.form.carreraId)
    },
    onPeriodoChange() {
      console.log('Período seleccionado:', this.form.periodoId)
      this.updateSelectedData()
    },
    onCarreraChange() {
      console.log('Carrera seleccionada:', this.form.carreraId)
      this.updateSelectedData()
    },
    resetForm() {
      this.form = {
        periodoId: null,
        carreraId: null,
        estado: null,
        observaciones: '',
      }
      this.selectedPeriod = null
      this.selectedProgram = null
    },
    handleSubmit() {
      console.log('Formulario actual:', this.form)
      console.log('Valores del formulario:', {
        periodoId: this.form.periodoId,
        carreraId: this.form.carreraId,
        estado: this.form.estado,
        observaciones: this.form.observaciones
      })

      // Validar que se hayan seleccionado período y carrera
      if (!this.form.periodoId || !this.form.carreraId) {
        console.log('❌ Validación fallida - valores faltantes')
        this.$bvToast.toast('Debe seleccionar un período y una carrera', {
          title: 'Error de Validación',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000,
        })
        return
      }

      const formData = {
        periodoId: parseInt(this.form.periodoId), // Asegurar que sea número entero
        carreraId: parseInt(this.form.carreraId), // Asegurar que sea número entero
        estado: this.form.estado || 'Borrador', // Establecer 'Borrador' como estado por defecto
        observaciones: this.form.observaciones || null,
        id: this.isEdit ? (this.schedulingData.id || this.schedulingData.programacionAcademicaId) : undefined,
        programacionAcademicaId: this.isEdit ? (this.schedulingData.programacionAcademicaId || this.schedulingData.id) : undefined,
      }

      console.log('✅ Datos a enviar:', formData) // Debug log

      // Emit the form data to parent
      this.$emit('submit', formData)
    },
  },
}
</script>
